// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page-contact:hover::-webkit-scrollbar-thumb {
  background-color: var(--color-scrollbar-thumbActive);
  border: 6px solid transparent;
}
.page-contact::-webkit-scrollbar-thumb:hover {
  background-color: var(--color-scrollbar-thumbHover);
}

.page-contact {
  color: var(--color-text);
  overflow: auto;
}
.page-contact .contact-content {
  display: flex;
  flex-direction: column;
  margin-inline: auto;
  max-width: 1200px;
  height: 100%;
}
.page-contact .contact-content .content-header {
  display: flex;
  flex-direction: column;
  margin-top: 120px;
}
.page-contact .contact-content .content-header .header-title {
  display: flex;
  justify-content: center;
  font-size: 68px;
  font-family: Ubuntu-M, sans-serif;
}
.page-contact .contact-content .content-header .header-title .title-midColor {
  color: #6c50a5;
  margin: 0 14px;
}
.page-contact .contact-content .content-header .header-subTitle {
  display: flex;
  justify-content: center;
  font-family: Ubuntu-R, sans-serif;
  font-size: 14px;
}
.page-contact .contact-content .content-card {
  display: flex;
  justify-content: center;
  position: relative;
  align-items: center;
  height: 100%;
}
.page-contact .contact-content .content-card .card-bg {
  background: #6c50a5;
  width: 81%;
  height: 400px;
  position: absolute;
  border-radius: 40px;
  border: 1px solid rgba(189, 189, 189, 0.4509803922);
  box-shadow: rgba(0, 0, 0, 0.45) 0px 25px 20px -20px;
}
.page-contact .contact-content .content-card .card-bg2 {
  width: 22%;
  height: 506px;
  border-radius: 40px;
}
.page-contact .contact-content .content-card .card-content {
  background: #bdbdbd;
  height: 500px;
  width: 80%;
  position: absolute;
  color: #000;
  display: flex;
  flex-direction: row;
  box-shadow: rgba(0, 0, 0, 0.45) 0px 25px 20px -20px;
}
.page-contact .contact-content .content-card .card-content .content-line {
  background-color: #a3a3a3;
  width: 1px;
  height: 80%;
  place-self: center;
}
.page-contact .contact-content .content-card .card-content .content-container {
  display: flex;
  flex: 1 1;
  padding: 10px;
  flex-direction: column;
}
.page-contact .contact-content .content-card .card-content .content-container .container-form {
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding: 28px 18px;
}
.page-contact .contact-content .content-card .card-content .content-container .container-form input {
  background: transparent;
  border: 1px solid #979797;
  border-radius: 4px;
  padding: 12px;
  font-family: Ubuntu-L, sans-serif;
}
.page-contact .contact-content .content-card .card-content .content-container .container-form input:focus {
  outline: none;
}
.page-contact .contact-content .content-card .card-content .content-container .container-form textarea {
  background: transparent;
  border: 1px solid #979797;
  border-radius: 4px;
  padding: 12px;
  resize: none;
  font-family: Ubuntu-L, sans-serif;
}
.page-contact .contact-content .content-card .card-content .content-container .container-form textarea:focus {
  outline: none;
}
.page-contact .contact-content .content-card .card-content .content-container .container-form button {
  background: #6c50a5;
  color: #fff;
  padding: 14px;
}
.page-contact .contact-content .content-card .card-content .content-container .container-form .disabled {
  cursor: unset;
  background: #575757;
}
.page-contact .contact-content .content-card .card-content .left {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: none;
  width: 38%;
}
.page-contact .contact-content .content-card .card-content .left svg {
  font-size: 180px;
  opacity: 0.4;
}

@media (max-width: 599px) {
  .page-contact .contact-content .content-header {
    margin-top: 0;
  }
  .page-contact .contact-content .content-header .header-title {
    font-size: 28px;
  }
  .page-contact .contact-content .content-header .header-subTitle {
    display: none;
  }
  .page-contact .contact-content .content-card .card-content {
    flex-direction: column;
    width: 96%;
  }
  .page-contact .contact-content .content-card .card-content .content-line {
    display: none;
  }
  .page-contact .contact-content .content-card .card-content .content-container {
    padding: 0;
  }
  .page-contact .contact-content .content-card .card-content .content-container .container-form {
    gap: 14px;
    padding: 0px 4px 4px;
  }
  .page-contact .contact-content .content-card .card-content .left {
    margin-top: 8px;
    width: unset;
    align-items: center;
  }
  .page-contact .contact-content .content-card .card-content .left svg {
    font-size: 80px;
  }
  .page-contact .contact-content .content-card .card-bg2 {
    width: 87%;
  }
}`, "",{"version":3,"sources":["webpack://./src/theme/scrollbar.scss","webpack://./src/pages/contact/contact.scss","webpack://./src/theme/responsiv.scss"],"names":[],"mappings":"AAwBE;EACE,oDAAA;EACA,6BAAA;ACvBJ;AD0BE;EACE,mDAAA;ACxBJ;;AAHA;EACE,wBAAA;EACA,cAAA;AAMF;AAJE;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;AAMJ;AAJI;EACE,aAAA;EACA,sBAAA;EACA,iBAAA;AAMN;AAJM;EACE,aAAA;EACA,uBAAA;EACA,eAAA;EACA,iCAAA;AAMR;AAJQ;EACE,cAAA;EACA,cAAA;AAMV;AAFM;EACE,aAAA;EACA,uBAAA;EACA,iCAAA;EACA,eAAA;AAIR;AAAI;EACE,aAAA;EACA,uBAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;AAEN;AAAM;EACE,mBAAA;EACA,UAAA;EACA,aAAA;EACA,kBAAA;EACA,mBAAA;EACA,mDAAA;EACA,mDAAA;AAER;AACM;EACE,UAAA;EACA,aAAA;EACA,mBAAA;AACR;AAEM;EACE,mBAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,mDAAA;AAAR;AAEQ;EACE,yBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;AAAV;AAGQ;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,sBAAA;AADV;AAGU;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,kBAAA;AADZ;AAGY;EACE,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,iCAAA;AADd;AAIY;EACE,aAAA;AAFd;AAKY;EACE,uBAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,YAAA;EACA,iCAAA;AAHd;AAMY;EACE,aAAA;AAJd;AAQY;EACE,mBAAA;EACA,WAAA;EACA,aAAA;AANd;AASY;EACE,aAAA;EACA,mBAAA;AAPd;AAaQ;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,UAAA;EACA,UAAA;AAXV;AAaU;EACE,gBAAA;EACA,YAAA;AAXZ;;AC/HI;EDyJE;IACE,aAAA;EAtBN;EAwBM;IACE,eAAA;EAtBR;EAyBM;IACE,aAAA;EAvBR;EA4BM;IACE,sBAAA;IACA,UAAA;EA1BR;EA4BQ;IACE,aAAA;EA1BV;EA6BQ;IACE,UAAA;EA3BV;EA6BU;IACE,SAAA;IACA,oBAAA;EA3BZ;EA+BQ;IACE,eAAA;IACA,YAAA;IACA,mBAAA;EA7BV;EA+BU;IACE,eAAA;EA7BZ;EAkCM;IACE,UAAA;EAhCR;AACF","sourcesContent":["%scrollbar {\n  /* custom scrollbar */\n  &::-webkit-scrollbar {\n    width: 12px;\n    -webkit-box-shadow: inset 2px 1px 4px -1px rgba(0,0,0,0.5);\n    -moz-box-shadow: inset 2px 1px 4px -1px rgba(0,0,0,0.5);\n    box-shadow: inset 2px 1px 4px -1px rgba(0,0,0,0.5);\n  }\n\n  &::-webkit-scrollbar-track {\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--color-scrollbar-thumb);\n    border: 6px solid transparent;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: var(--color-scrollbar-thumbHover);\n  }\n}\n\n%scrollbarHover {\n  &::-webkit-scrollbar-thumb {\n    background-color: var(--color-scrollbar-thumbActive);\n    border: 6px solid transparent;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background-color: var(--color-scrollbar-thumbHover);\n  }\n}","@import '../../theme/scrollbar.scss';\n@import '../../theme/responsiv.scss';\n\n.page-contact {\n  color: var(--color-text);\n  overflow: auto;\n\n  .contact-content {\n    display: flex;\n    flex-direction: column;\n    margin-inline: auto;\n    max-width: 1200px;\n    height: 100%;\n\n    .content-header {\n      display: flex;\n      flex-direction: column;\n      margin-top: 120px;\n\n      .header-title {\n        display: flex;\n        justify-content: center;\n        font-size: 68px;\n        font-family: Ubuntu-M, sans-serif;\n\n        .title-midColor {\n          color: #6c50a5;\n          margin: 0 14px;\n        }\n      }\n\n      .header-subTitle {\n        display: flex;\n        justify-content: center;\n        font-family: Ubuntu-R, sans-serif;\n        font-size: 14px;\n      }\n    }\n\n    .content-card {\n      display: flex;\n      justify-content: center;\n      position: relative;\n      align-items: center;\n      height: 100%;\n\n      .card-bg {\n        background:#6c50a5;\n        width: 81%;\n        height: 400px;\n        position: absolute;\n        border-radius: 40px;\n        border: 1px solid #bdbdbd73;\n        box-shadow: rgba(0, 0, 0, 0.45) 0px 25px 20px -20px;\n      }\n      \n      .card-bg2 {\n        width: 22%;\n        height: 506px;\n        border-radius: 40px;\n      }\n\n      .card-content {\n        background: #bdbdbd;\n        height: 500px;\n        width: 80%;\n        position: absolute;\n        color: #000;\n        display: flex;\n        flex-direction: row;\n        box-shadow: rgba(0, 0, 0, 0.45) 0px 25px 20px -20px;\n\n        .content-line {\n          background-color: #a3a3a3;\n          width: 1px;\n          height: 80%;\n          place-self: center;\n        }\n\n        .content-container {\n          display: flex;\n          flex: 1;\n          padding: 10px;\n          flex-direction: column;\n\n          .container-form {\n            display: flex;\n            flex-direction: column;\n            gap: 24px;\n            padding: 28px 18px;\n\n            input {\n              background: transparent;\n              border: 1px solid #979797;\n              border-radius: 4px;\n              padding: 12px;\n              font-family: Ubuntu-L, sans-serif;\n            }\n\n            input:focus {\n              outline: none;\n            }\n\n            textarea {\n              background: transparent;\n              border: 1px solid #979797;\n              border-radius: 4px;\n              padding: 12px;\n              resize: none;\n              font-family: Ubuntu-L, sans-serif;\n            }\n\n            textarea:focus {\n              outline: none;\n            }\n\n            \n            button {\n              background: #6c50a5;\n              color: #fff;\n              padding: 14px;\n            }\n\n            .disabled {\n              cursor: unset;\n              background: #575757;\n            }\n          }\n\n        }\n\n        .left {\n          display: flex;\n          align-items: center;\n          justify-content: center;\n          flex: none;\n          width: 38%;\n\n          svg {\n            font-size: 180px;\n            opacity: 0.4;       \n          }\n        }\n      }\n    }\n  }\n}\n\n.page-contact:hover {\n  @extend %scrollbarHover;\n}\n\n@include appSize(phone-only) {    \n  .page-contact {\n    .contact-content {  \n      .content-header {\n        margin-top: 0;\n  \n        .header-title {  \n          font-size: 28px;  \n        }\n  \n        .header-subTitle {\n          display: none;\n        }\n      }\n\n      .content-card {\n        .card-content {\n          flex-direction: column;\n          width: 96%;\n\n          .content-line {\n            display: none;\n          }\n\n          .content-container {\n            padding: 0;\n\n            .container-form {\n              gap: 14px;\n              padding: 0px 4px 4px;\n            }\n          }\n\n          .left {\n            margin-top: 8px;\n            width: unset;\n            align-items: center;\n\n            svg {\n              font-size: 80px;\n            }\n          }\n        }\n\n        .card-bg2 {\n          width: 87%;\n        }\n      }\n    }\n  }\n}","@mixin appSize($size) {\n  @if $size == phone-only {\n    @media (max-width: 599px) { @content; }\n  } @else if $size == tablet-portrait-up {\n    @media (min-width: 600px) { @content; }\n  } @else if $size == tablet-landscape-up {\n    @media (min-width: 900px) { @content; }\n  } @else if $size == desktop-up {\n    @media (min-width: 1200px) { @content; }\n  } @else if $size == big-desktop-up {\n    @media (min-width: 1800px) { @content; }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
